/* ===========================================================================
   Loader
   =========================================================================== */

import { loadingClass } from '../settings/settings';

const $loader = document.querySelector('.loader');

/**
 * [showLoader description]
 * @param  {[type]} $elem [description]
 * @return {[type]}       [description]
 */
export function showLoader($elem) {
  $elem.classList.add(loadingClass);
}

/**
 * [hideLoader description]
 * @param  {[type]} $elem [description]
 * @return {[type]}       [description]
 */
export function hideLoader($elem) {
  $elem.classList.remove(loadingClass);
}
